import { FC } from 'react'
import styled from 'styled-components'

import Container from 'components/layout/Container'
import { media, mediaMax } from 'styles/media'
import typeStyle from 'styles/typeStyle'
import Button from 'components/display/Button'
import SvgBrandMap from 'components/icons/brand/BrandMap'

const Wrapper = styled.div`
  padding: 40px 16px;
  background-color: ${({ theme }) => theme.brand.sand};

  a {
    color: ${({ theme }) => theme.brand.jungle};
    text-decoration: underline;
  }

  h2 {
    ${typeStyle('-ds-font-section-title-regular')}
  }

  svg {
    width: 64px;
    height: 64px;
    margin-right: 24px;
    margin-bottom: 20px;
  }

  ${media.md`
    font-size: 18px;
    padding: 56px 32px;

    svg {
      width: 80px;
      height: 80px;
      margin-right: 32px;
    }
  `}
`

const Content = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;

  flex-direction: column;

  ${media.md`
    flex-direction: row;
  `}

  ${Button} {
    font-size: 16px !important;
  }

  ${mediaMax.md`
    ${Button} {
      margin-top: 16px;
    }
  `}
  ${media.md`
    font-size: 20px;
  `}

  > div:first-child {
    display: flex;

    p {
      flex: 1;
      margin: 0;
      padding-right: 16px;
    }

    ${media.md`
      align-items: center;
    `}
  }
`

const Inner = styled.div`
  display: flex;
`

const Subheading = styled.h2`
  text-transform: capitalize;
  margin-bottom: 20px;
`

type Props = {
  marketName: string
}

const EmptyBanner: FC<Props> = ({ marketName }) => {
  return (
    <Container>
      <Wrapper>
        <Inner>
          <Content>
            <SvgBrandMap />
            <div style={{ flex: 1 }}>
              <Subheading>Watch This Space</Subheading>
              <p>
                We&apos;re still discovering unique accommodation and adventures
                in this region. In the meantime, check out some of our other
                soul-fulfilling escapes in {marketName}.
              </p>
              <Button
                as="a"
                href="./"
                css={`
                  display: inline-block;
                  margin-top: 20px;
                  color: white !important;
                `}
              >
                Explore all {marketName}
              </Button>
            </div>
          </Content>
        </Inner>
      </Wrapper>
    </Container>
  )
}

export default EmptyBanner
